export default __webpack_public_path__ + "static/media/mac.f0c7010c.png";